import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Page from '@lib/components/v2/Page';
import { DOCUMENTS } from '@lib/constants/documents';
import { TickIcon, UncheckedRadioIcon } from '@lib/components/v2/icons';

import classes from './DocumentListScreen.style.module.scss';

export const DocumentListScreen = ({
  title,
  description,
  documentList,
  onClickDocumentItem,
  footerButtons,
  progressBarPercentage,
  hideDocImages = false
}) => {
  const { TICK_ICON_COLOR = '#00D996' } = process.env;

  return (
    <Page buttons={footerButtons}>
      <div className={classes.wrapper}>
        <div className={classes.heading} data-testid="docs-heading">
          {title}
        </div>
        <div className={classes.description} data-testid="docs-instruction">
          {description}
        </div>
        <div className={classes.document_list}>
          {documentList.map((item, index) => {
            return (
              <div
                key={item.title}
                className={classNames(classes.document_item, item.checked && classes.checked)}
                onClick={() => onClickDocumentItem(item, index)}
              >
                <div
                  className={classNames(
                    classes.check_mark_wrapper,
                    item.checked && classes.checked
                  )}
                  data-testid={`docs-radio-${index}`}
                >
                  {item.checked ? <TickIcon color={TICK_ICON_COLOR} /> : <UncheckedRadioIcon />}
                </div>
                <div className={classes.document_title} data-testid={`docs-doc-${index}`}>
                  {item.title}
                </div>
                {!hideDocImages && (
                  <div className={classes.card_wrapper} data-testid={`docs-img-${index}`}>
                    <img
                      className={classNames(
                        classes.img_card,
                        item.type === DOCUMENTS.PASSPORT.documentType
                          ? classes.passport
                          : classes.card
                      )}
                      src={`images/icons/svg/${item.icon}`}
                      alt=""
                    />
                  </div>
                )}
              </div>
            );
          })}
        </div>
        {progressBarPercentage > 0 && (
          <div className={classes.progress_bar} style={{ width: `${progressBarPercentage}%` }} />
        )}
      </div>
    </Page>
  );
};

DocumentListScreen.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  documentList: PropTypes.array,
  onClickDocumentItem: PropTypes.func,
  footerButtons: PropTypes.array,
  progressBarPercentage: PropTypes.number,
  hideDocImages: PropTypes.bool
};
